import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { writeLog } from 'src/app/shared/misc/logs';
import { AppSettings, Contact, ContactManagerData, Group } from 'src/app/shared/model';
import { AlertService } from 'src/app/shared/service/alert.service';
import { MiscService } from 'src/app/shared/service/misc.service';

@Component({
  selector: 'app-text-import',
  templateUrl: './text-import.component.html',
  styleUrls: ['./text-import.component.scss']
})
export class TextImportComponent implements OnInit {
  importRecipientError = false;
  tempImportList: string;
  groups: Group[] = [];
  selectedGroup: Group;
  contacts: Contact[] = [];
  selectedTxtDelimiter = 0;
  txtDelimiters = ['Comma', 'New Line'];
  skippedContacts = 0;
  fileProcessed = false;

  constructor(
    public dialogRef: MatDialogRef<TextImportComponent>,
    private alert: AlertService,
    private miscService: MiscService,
    @Inject(MAT_DIALOG_DATA) public data: ContactManagerData,
    ) {}

  ngOnInit() {
    // set contact group to null or selectedGroup
    this.selectedGroup = this.data.selectedGroup;

    writeLog('selected group', this.selectedGroup);

    this.data.groups.subscribe(
        (res) => {
          this.groups = res;

          // if null set to first group item in groups []
          if (!this.selectedGroup && this.groups.length > 0) {
            this.selectedGroup = this.groups[0];
          }
        }
    );
  }

  resetUpload() {
    this.importRecipientError = false;
    this.tempImportList = '';
    this.selectedGroup = this.groups[0];
    this.contacts = [];
    this.skippedContacts = 0;
    this.fileProcessed = false;
  }

  setGroupForContacts() {
    for (let i = 0; i < this.contacts.length; i++) {
      this.contacts[i].group_id = this.selectedGroup.id;
    }
  }

  // onQuickImport() {
  //   let dupesCount = 0;

  //   if (this.tempImportList.length === 0) {
  //     this.alert.alert({
  //       message:
  //         'You have to enter a list of contacts, each on a separate line.'
  //     });
  //     return;
  //   }

  //   const recipients = this.tempImportList.trim().split(/\r*\n\,?/);
  //   writeLog('recipients', recipients);

  //   if (recipients.length === 0) {
  //     this.alert.alert({
  //       message:
  //         'You have to enter a list of contacts, each on a separate line.'
  //     });
  //     return;
  //   }

  //   if (!this.onCheckImportContacts()) {
  //     this.alert.alert({
  //       message:
  //         'One or more contacts is incorrectly formed. kindly check and import again.'
  //     });
  //     return;
  //   }

  //   recipients.forEach(_contact => {
  //     if (!this.miscService.checkMobile(_contact)) {
  //       this.importRecipientError = true;
  //       return;
  //     }

  //     _contact = this.miscService.correctMobile(_contact);

  //     if (this.isDuplicate(_contact)) {
  //       dupesCount++;
  //     } else {
  //       this.contacts.push({
  //         othername: '',
  //         surname: '',
  //         mobile: _contact,
  //         group_id: this.selectedGroup.id,
  //       });
  //     }
  //   });

  //   this.tempImportList = '';

  //   this.dialogRef.close(this.contacts);
  // }

  onCheckImportContacts(): boolean {

    writeLog('delimiter', this.selectedTxtDelimiter);

    let delimiter = ',';
    switch(this.selectedTxtDelimiter) {
      case 0:
        // comma
        delimiter = ',';
        break;

      case 1:
        // new line
        delimiter = '\n';
        break;

      default:
        // new line
        delimiter = '\n';
        break;
    }

    let arr = this.tempImportList.split(delimiter);
    writeLog('arr', arr);


    arr.forEach(item => {
      // start
      const newContact = new Contact();
      newContact.group_id = this.selectedGroup ? this.selectedGroup.id : 0;
      // newContact.mobile = this.miscService.trimMobile(item);
      newContact.mobile = this.miscService.formatCountryPhone(AppSettings.COUNTRY_ORIGIN, item);

      if(!newContact.mobile.length) {
        this.skippedContacts++;
        return;
      }

      this.contacts.push(newContact);
    });

    if(!this.contacts.length) {
      this.alert.alert({
        message: 'Sorry, something went wrong. Make sure the file contains valid data, then try the upload again.'
      });
      this.resetUpload();
      return;
    }

    this.fileProcessed = true;
  }

  isDuplicate(mobile: string): boolean {
    return this.contacts.filter(_contact => _contact.mobile === mobile).length > 0;
  }

  removeRecipient(index: number) {
    this.contacts.splice(index, 1);
  }

  onImport() {
    if (!this.contacts.length) {
      this.alert.alert({
        message: 'Something is not right. Try again'
      });
      this.resetUpload();
      return;
    }

    this.dialogRef.close(this.contacts);
  }

}
